<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_ca44"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="combinedPayment_search_button" @click="funcFilter">
          查询
        </el-button>
        <el-button
          v-if="combinedPayment_statusQuery_button"
          @click="statusQuery"
        >
          更新付款结果
        </el-button>
        <el-button
          v-if="combinedPayment_orderShareBatch_button"
          @click="OrderShareBatch"
        >
          批量分账
        </el-button>
        <el-button
          v-if="getLimit('combinedPayment_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      border
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      :checkbox-config="{ labelField: 'name', checkMethod: checkMethod2 }"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="outTradeNo"
          title="交易流水号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.outTradeNo"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderNo"
          title="网商支付订单号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderNo"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payerName"
          title="付款人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payerName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payeeName"
          title="收款人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payeeName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="totalAmount"
          title="金额(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.totalAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.totalAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="状态"
          :formatter="formatterStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" clearable placeholder="请选择">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderDetailNumber"
          title="运输单号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="errorCode"
          title="错误码"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.errorCode"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="errorDesc"
          title="错误描述"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.errorDesc"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="memo" title="备注" min-width="250" sortable />
        <template v-slot:header>
          <el-input
            v-model="listQuery.memo"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column title="操作" min-width="50" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="
              combinedPayment_rePayment_button && scope.row.status == 'FAIL'
            "
            class="item"
            effect="dark"
            content="重新支付"
            placement="top"
          >
            <vxe-button type="text" @click="rePayment(scope.row.orderNo)">
              <i class="el-icon-refresh-left" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              combinedPayment_OrderShare_button && scope.row.status == 'SUCCESS'
            "
            class="item"
            effect="dark"
            content="分账"
            placement="top"
          >
            <vxe-button type="text" @click="orderShare(scope.row)">
              <i class="el-icon-refresh-left" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <!-- 弹出失败提示-->
    <el-dialog
      title="失败信息"
      :visible.sync="dialogTableVisible"
      class="abow_dialog"
    >
      <el-table :data="errorData" height="100%" border>
        <el-table-column property="code" label="订单号" width="290" />
        <el-table-column property="msg" label="错误描述" width="300" />
      </el-table>
    </el-dialog>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import {
  getPrepayPushList,
  obtainPrepayPushAgain,
  obtainPrepayPushQuery,
  orderShareApply
} from "@/api/InternetBanking";
import { getLimit } from "@/utils/getLimit.js";

export default {
  data() {
    return {
      exportObj: {
        exportUrl: "ntocc-tms-api/mybankPrepay/exportMyBankPrepayPush", //导出接口
        name: "合并支付"
      },
      loading: false,
      dialogTableVisible: false,
      combinedPayment_search_button: false, //查询
      combinedPayment_statusQuery_button: false, //更新付款结果
      combinedPayment_orderShareBatch_button: false, //批量分账
      combinedPayment_rePayment_button: false, //重新支付
      combinedPayment_OrderShare_button: false, //分账
      tableData: [],
      errorData: [],
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      statusOptions: [
        { value: "SUCCESS", label: "成功" },
        { value: "FAIL", label: "失败" },
        { value: "DEALING", label: "处理中" },
        { value: "FINISHED", label: "分账完成" }
      ],
      Reclassification: [],
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.findList();
    this.combinedPayment_search_button = getLimit(
      "combinedPayment_search_button"
    );
    this.combinedPayment_statusQuery_button = getLimit(
      "combinedPayment_statusQuery_button"
    );
    this.combinedPayment_orderShareBatch_button = getLimit(
      "combinedPayment_orderShareBatch_button"
    );
    this.combinedPayment_rePayment_button = getLimit(
      "combinedPayment_rePayment_button"
    );
    this.combinedPayment_OrderShare_button = getLimit(
      "combinedPayment_OrderShare_button"
    );
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        getPrepayPushList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    //支付状态查询
    statusQuery() {
      const rLoading = this.openLoading();
      obtainPrepayPushQuery().then(response => {
        rLoading.close();
        if (response.status === 500) {
          this.dialogTableVisible = true;
          this.errorData = response.data;
        } else {
          let type = response.status === 0 ? "success" : "error";
          this.findList();
          this.$message({
            message: response.msg,
            type: type
          });
        }
      });
    },
    //重新支付
    rePayment(c) {
      this.$confirm("是否重新支付?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const rLoading = this.openLoading();
          obtainPrepayPushAgain(c).then(response => {
            rLoading.close();
            this.findList();
            this.$message({
              message: response.msg,
              type: "success"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    //分账
    orderShare(c) {
      this.Reclassification = [];
      this.Reclassification.push({ relateOrderNo: c.orderNo, shareType: 1 });
      this.$confirm("是否分账?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const rLoading = this.openLoading();
          orderShareApply(this.Reclassification).then(response => {
            rLoading.close();
            if (response.status === 500) {
              this.dialogTableVisible = true;
              this.errorData = response.data;
            } else {
              let type = response.status === 0 ? "success" : "error";
              this.findList();
              this.$message({
                message: response.msg,
                type: type
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 批量分账
    OrderShareBatch() {
      const checkedRowArray = this.$refs.xTable.getCheckboxRecords();
      if (!checkedRowArray || checkedRowArray.length === 0) {
        this.$message({
          message: "请选择需要分账的项",
          type: "warning"
        });
        return false;
      }
      if (checkedRowArray.length > 100) {
        this.$message({
          message: "批量处理最多100条数据",
          type: "warning"
        });
        return false;
      }
      this.Reclassification = [];
      checkedRowArray.map(item => {
        this.Reclassification.push({
          relateOrderNo: item.orderNo,
          shareType: 1
        });
      });
      const rLoading = this.openLoading();
      this.$refs.xTable.clearCheckboxRow();
      orderShareApply(this.Reclassification)
        .then(response => {
          rLoading.close();
          if (response.status === 500) {
            this.dialogTableVisible = true;
            this.errorData = response.data;
          } else {
            let type = response.status === 0 ? "success" : "error";
            this.findList();
            this.$message({
              message: response.msg,
              type: type
            });
          }
        })
        .finally(f => {
          rLoading.close();
          this.findList();
        });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    // 翻译状态
    formatterStatus({ cellValue }) {
      const item = this.statusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    checkMethod2({ row }) {
      return row.status === "SUCCESS";
    }
  }
};
</script>
<style scoped>
.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
}

::v-deep .el-dialog {
  margin: 0 auto !important;
  height: 60%;
  width: 32%;
  overflow: hidden;
}

::v-deep .el-dialog .el-dialog__body {
  position: absolute;
  left: 10px;
  top: 58px;
  bottom: 0;
  right: 0;
  padding: 0;
  z-index: 1;
  overflow: hidden;
  overflow-y: auto;
}
</style>
